/* eslint-disable import/no-named-as-default */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Parser from "html-react-parser";
import EditButton from "../shared/button/EditButton";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import AboutMeEdit from "./EditForms/AboutMeEdit";
import {
  Wrapper,
  Title,
  Body,
  ReadMore,
  ReadMoreButton,
} from "./styles/about-agent-styles";

export class AboutAgent extends Component {
  state = {
    editAboutMeActive: false,
  };

  toggleEditAboutMe = () => {
    this.setState(({ editAboutMeActive }) => ({
      editAboutMeActive: !editAboutMeActive,
    }));
  };

  render() {
    const {
      user,
      currentUser,
      aboutAgent,
      toggleAboutAgentModal,
      aboutMeFormLoading,
    } = this.props;
    const { editAboutMeActive } = this.state;
    const defaultText = currentUser.isRecruiter
      ? "Please add your information here"
      : "We're working on building our profile right now";

    return (
      <Wrapper className="animated delay-7 fadeIn" noData={!aboutAgent}>
        {aboutMeFormLoading && <WidgetLoading />}
        {editAboutMeActive && (
          <AboutMeEdit toggleEditAboutMe={this.toggleEditAboutMe} />
        )}
        {currentUser.isRecruiter && (
          <EditButton
            onClickAction={this.toggleEditAboutMe}
            top={8}
            right={10}
          />
        )}
        <Title>
          About {user.firstName} {user.lastName}
        </Title>
        {aboutAgent ? (
          <Body data-test-id="about-agent">{Parser(aboutAgent)}</Body>
        ) : (
          <Body data-test-id="default-about-agent" noData>
            {defaultText}
          </Body>
        )}
        {aboutAgent && aboutAgent.length > 380 && (
          <ReadMore>
            <ReadMoreButton
              data-test-id="read-more-button"
              onClick={() => toggleAboutAgentModal()}
            >
              read more
            </ReadMoreButton>
          </ReadMore>
        )}
      </Wrapper>
    );
  }
}

AboutAgent.propTypes = {
  aboutAgent: PropTypes.string,
  toggleAboutAgentModal: PropTypes.func.isRequired,
  user: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }).isRequired,
  currentUser: PropTypes.shape({
    isRecruiter: PropTypes.bool.isRequired,
  }).isRequired,
  aboutMeFormLoading: PropTypes.bool.isRequired,
};

AboutAgent.defaultProps = {
  aboutAgent: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  aboutAgent: state.agencyProfile.profileData.aboutAgent,
  user: state.agencyProfile.profileData.user,
  currentUser: state.agencyProfile.profileData.currentUser,
  aboutMeFormLoading: state.agencyProfile.aboutMeFormLoading,
});

export default connect(mapStateToProps, {})(AboutAgent);
